import React from 'react';
import { Hero } from '../components/Hero';
import { Features } from '../components/Features';
import { Pricing } from '../components/Pricing';
import { FAQSection } from '../components/FAQ';
import { CallToAction } from '../components/CallToAction';

const HomePage: React.FC = () => {
  return (
    <main>
      <Hero />
      <Features />
      <Pricing />
      <FAQSection />
      <CallToAction />
    </main>
  );
};

export default HomePage;